import { Divider } from '@chakra-ui/react';
import React, { KeyboardEventHandler, useCallback } from 'react';
import TextArea from 'react-autosize-textarea';
import { useContextSelector } from 'use-context-selector';
import wrapColorTheme from '../../lib/WrapColorTheme';
import { styled } from '../../Stitches';
import EditorContext from './EditorContext';

const StyledTextArea = styled(TextArea, {
  borderWidth: '1px',
  borderRadius: '4px',
  borderColor: 'rgba(0, 0, 0, 0)',
  width: '100%',

  paddingLeft: '8px',
  paddingRight: '8px',

  marginLeft: '-$3',
  marginRight: '-$3',

  fontFamily: '$heading',
  fontSize: '2.3em',
  lineHeight: '2em',
  fontWeight: '500',

  background: 'rgba(0, 0, 0, 0)',
  resize: 'none',
  outline: 'none',

  variants: {
    theme: {
      dark: {
        '&:hover': {
          borderColor: 'rgba(255, 255, 255, 0.44)',
          transition: '200ms ease',
        },
      },
      light: {
        '&:hover': {
          borderColor: 'rgba(0, 0, 0, 0.44)',
          transition: '200ms ease',
        },
      },
    },
  },
});

const ThemedStyledTextArea = wrapColorTheme(StyledTextArea);

const StyledDivider = styled(Divider, {
  marginRight: '$2',
  marginLeft: '$2',
  marginBottom: '$6',
});

const preventEnter: KeyboardEventHandler<any> = (event: any) => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
};

const LetterTitle = () => {
  const dispatch = useContextSelector(EditorContext, (ctx) => ctx.dispatch);
  const title = useContextSelector(EditorContext, (ctx) => ctx.document?.title);

  const updateTitle = useCallback(
    (title: string) => dispatch({ type: 'Document', event: { type: 'TITLE_UPDATED', title } }),
    [dispatch]
  );

  const onChange = useCallback(
    (e: any) => {
      const value = e.target.value;
      const valueSansNewLines = [...value]
        .filter((c: any) => c !== '\n')
        .reduce((p, cur) => p + cur, '');

      updateTitle(valueSansNewLines);
    },
    [updateTitle]
  );

  return (
    <>
      <ThemedStyledTextArea
        readOnly={title === undefined}
        onKeyDown={preventEnter}
        placeholder="Title"
        maxLength={50}
        onChange={onChange}
        value={title}
      />
      <StyledDivider />
    </>
  );
};

export const ReadOnlyLetterTitle = ({ title }: { title: string }) => (
  <>
    <StyledTextArea readOnly defaultValue={title} />
    <StyledDivider />
  </>
);

export default LetterTitle;
